var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8 6.3C4.34875 6.3 5.6 7.55125 5.6 9.1C5.6 10.6487 4.34875 11.9 2.8 11.9C1.25125 11.9 0 10.6487 0 9.1C0 7.55125 1.25125 6.3 2.8 6.3ZM9.45 10.5C9.91413 10.5 10.3592 10.6844 10.6874 11.0126C11.0156 11.3408 11.2 11.7859 11.2 12.25C11.2 12.7141 11.0156 13.1592 10.6874 13.4874C10.3592 13.8156 9.91413 14 9.45 14C8.98587 14 8.54075 13.8156 8.21256 13.4874C7.88437 13.1592 7.7 12.7141 7.7 12.25C7.7 11.7859 7.88437 11.3408 8.21256 11.0126C8.54075 10.6844 8.98587 10.5 9.45 10.5ZM9.8 0C10.3516 0 10.8977 0.108636 11.4073 0.319706C11.9168 0.530776 12.3798 0.840146 12.7698 1.23015C13.1599 1.62016 13.4692 2.08316 13.6803 2.59273C13.8914 3.1023 14 3.64845 14 4.2C14 6.51875 12.1187 8.4 9.8 8.4C8.68609 8.4 7.6178 7.9575 6.83015 7.16985C6.0425 6.3822 5.6 5.31391 5.6 4.2C5.6 1.88125 7.48125 0 9.8 0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkills);
export default __webpack_public_path__ + "static/media/skills.8d57cc71.svg";
export { ForwardRef as ReactComponent };